'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import GlobalHelper from '../../Common/Helpers/GlobalHelper';

/**
 * Importación de las Actions.
 */
import {
    GET_CLIENT_DATA,
    GET_CLIENT_DATA_RESULT,
    SELECT_TAB,
    OPEN_MODAL_INFOCLIENTE,
    CLOSE_MODAL_INFOCLIENTE,
    SET_USER_FUNCTIONS,
    RELOAD_VISTA_CLIENTE,
    OPEN_MODAL_DISTRIBUIRLIMITES,
    CLOSE_MODAL_DISTRIBUIRLIMITES,
    OPEN_MODAL_CONFIRMADOR,
    ROUTE_TO_ADMINISTRADORA_VISTA_CLIENTE,
    RESET_ROUTE_TO_ADMINISTRADORA_VISTA_CLIENTE,
    RESET_STATE_VISTA_CLIENTE,
    ACTUALIZAR_LIMITES_VISTA_CLIENTE,
    OPEN_PANEL_SELECCION,
    CLOSE_MODAL_MSG_CONFIRMADOR,
    STOP_SPINER,
    ROUTE_TO_NUEVA_SOLICITUD_CUENTA_VISTA_CLIENTE,
    NUEVA_SOLICITUD_ADICIONAL_CUENTA_EXISTENTE,
    CAMBIAR_ESTADO_SOLICITUD,
    ROUTE_TO_EMPRESA,
    REDIRECT_TO_AVISO_VIAJE
} from '../../Screens/VistaCliente/actions/VistaClienteActions';

import { RETURN_VISTA_CLIENTE } from '../../Screens/PanelSeleccion/actions/PanelSeleccionActions';

import {
    CLOSE_MODAL_CONFIRMADOR,
    OPEN_MODAL_MSG_CONFIRMACION_SOLICITUD,
    OPEN_MODAL_MSG_DENEGACION_SOLICITUD
} from '../../Screens/ConfirmadorSolicitud/actions/Actions';


/**
 * Estado inicial.
 */
const initialState = {
    data: {
        loading: false,
        modalVisible: false,
        modalVisibleConfirmador: false,
        modalVisibleMsgConfirmador: false,
        mensajeConfirmador: "",
        client: { description: "" },
        administrators: [],
        enterprises: [],
        empresasNoModificadas: [],
        cuentasNoModificadas: [],
        administratorSelected: undefined,
        GET_DATOS_CLIENTE_BY_ID: [],
        GET_SOLICITUD_EN_CURSO_BY_CLIENTE: [],
        consultaSociosFunctionsAllowed: undefined,
        solicitudFunctionsAllowed: undefined,
        userFeatures: undefined,
        esPersonaFisica: undefined,
        redirect: false,
        redirectToCuenta: false,
        redirectToCuentaCliente: false,
        informacionBorrador: undefined,
        entidadTipo: undefined,
        activoPanelSeleccion: false,
        idEntidad: 0,
        solicitudId: 0,
        novedadesEmpresas: [],
        showAvisoViaje:false
    }
};

let result;

function vistaCliente(state = initialState, action) {
    LogHelper.In(vistaCliente.name, state, action);

    switch (action.type) {

        case GET_CLIENT_DATA:

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: true,
                    client: action.cliente
                }
            };
            break;

        case GET_CLIENT_DATA_RESULT:

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: false,
                    client: action.data.client,
                    administrators: action.data.administrators,
                    enterprises: action.data.enterprises,
                    administratorSelected: action.data.administratorSelected,
                    GET_DATOS_CLIENTE_BY_ID: action.data.GET_DATOS_CLIENTE_BY_ID,
                    GET_EMPRESA_CUIT: action.data.GET_EMPRESA_CUIT,
                    GET_CUENTA_TARJETA_BY_CUIT: action.data.GET_CUENTA_TARJETA_BY_CUIT,
                    GET_CUENTA_TARJETA_CON_BAJA_BY_CUIT: action.data.GET_CUENTA_TARJETA_CON_BAJA_BY_CUIT,
                    GET_ADMINISTRADORA: action.data.GET_ADMINISTRADORA,
                    GET_CLIENTE_CUIT: action.data.GET_CLIENTE_CUIT,
                    GET_SOLICITUD_EN_CURSO_BY_CLIENTE: action.data.GET_SOLICITUD_EN_CURSO_BY_CLIENTE,
                    selectLimit: 0,
                    esPersonaFisica: action.data.client.esPersonaFisica,
                    informacionBorrador: action.data.informacionBorrador,
                    modalVisibleConfirmador: false,
                    CONSULTA_SOLICITUD_CUENTA_CLIENTE: action.data.CONSULTA_SOLICITUD_CUENTA_CLIENTE && action.data.CONSULTA_SOLICITUD_CUENTA_CLIENTE[0] ? action.data.CONSULTA_SOLICITUD_CUENTA_CLIENTE[0] : action.data.CONSULTA_SOLICITUD_CUENTA_CLIENTE,
                    CONSULTA_SOLICITUDES_CUENTA: action.data.GET_SOLICITUDES_BY_ID_CLIENTE ? action.data.GET_SOLICITUDES_BY_ID_CLIENTE.filter(solicitud => solicitud.marcaId == 1) : [],
                    CONSULTA_SOLICITUDES_CUENTA_CABAL: action.data.GET_SOLICITUDES_BY_ID_CLIENTE ? action.data.GET_SOLICITUDES_BY_ID_CLIENTE.filter(solicitud => solicitud.marcaId == 2) : [],
                    CONSULTA_SOLICITUDES_CUENTA_MASTER: action.data.GET_SOLICITUDES_BY_ID_CLIENTE ? action.data.GET_SOLICITUDES_BY_ID_CLIENTE.filter(solicitud => solicitud.marcaId == 3) : [],
                    CONSULTA_TARJETAS: action.data.CONSULTA_TARJETAS,
                    CONSULTA_TARJETAS_CABAL: action.data.CONSULTA_TARJETAS_CABAL,
                    CONSULTA_TARJETAS_MASTER: action.data.CONSULTA_TARJETAS_MASTER,
                    CONSULTA_SOLICITUD_CUENTA_CUENTAS_VISA: action.data.CONSULTA_SOLICITUD_CUENTA_CUENTAS_VISA,
                    CONSULTA_SOLICITUD_CUENTA_CUENTAS_OTRAS: action.data.CONSULTA_SOLICITUD_CUENTA_CUENTAS_OTRAS,
                    CONSULTA_SOLICITUD_CUENTA_CUENTAS_INTEGRANTES: action.data.CONSULTA_SOLICITUD_CUENTA_CUENTAS_INTEGRANTES,
                    CONSULTA_SOLICITUD_CUENTA_EMPRESA: action.data.CONSULTA_SOLICITUD_CUENTA_EMPRESA,
                    enterprises: action.data.CONSULTA_SOLICITUD_CUENTA_EMPRESA
                }
            };
            break;

        case NUEVA_SOLICITUD_ADICIONAL_CUENTA_EXISTENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    redirectToAdicionales: true
                }
            }

            break;

        case OPEN_MODAL_INFOCLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    modalVisibleUserDetails: true
                }
            };
            break;

        case CLOSE_MODAL_INFOCLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    modalVisibleUserDetails: false
                }
            };
            break;

        case OPEN_MODAL_CONFIRMADOR:

            result = {
                ...state,
                data: {
                    ...state.data,
                    modalVisibleConfirmador: true,
                    solicitudId: action.solicitudId
                }
            };
            break;

        case CLOSE_MODAL_CONFIRMADOR:

            result = {
                ...state,
                data: {
                    ...state.data,
                    modalVisibleConfirmador: false
                }
            };
            break;

        case OPEN_MODAL_MSG_CONFIRMACION_SOLICITUD:

            cambiarEstadoSolicitud(state, 3);

            result = {
                ...state,
                data: {
                    ...state.data,
                    modalVisibleMsgConfirmador: true,
                    modalVisibleConfirmador: false,
                    loading: false,
                    mensajeConfirmador: "La solicitud ha sido confirmada."
                }
            };
            break;

        case OPEN_MODAL_MSG_DENEGACION_SOLICITUD:

            cambiarEstadoSolicitud(state, 4);

            result = {
                ...state,
                data: {
                    ...state.data,
                    modalVisibleMsgConfirmador: true,
                    modalVisibleConfirmador: false,
                    loading: false,
                    mensajeConfirmador: "La solicitud ha sido denegada."
                }
            };
            break;

        case CLOSE_MODAL_MSG_CONFIRMADOR:

            result = {
                ...state,
                data: {
                    ...state.data,
                    modalVisibleMsgConfirmador: false,
                    loading: false,
                    mensajeConfirmador: ""
                }
            };
            break;

        case SELECT_TAB:

            result = {
                ...state,
                data: {
                    ...state.data,
                    administratorSelected: action.selectedId
                }
            };
            break;
        case CAMBIAR_ESTADO_SOLICITUD:

            let solicitudesAux = JSON.parse(JSON.stringify(state.data.CONSULTA_SOLICITUDES_CUENTA));
            let solicitudesAuxCabal = JSON.parse(JSON.stringify(state.data.CONSULTA_SOLICITUDES_CUENTA_CABAL));
            let solicitudesAuxMaster = JSON.parse(JSON.stringify(state.data.CONSULTA_SOLICITUDES_CUENTA_MASTER));

            //SE CAMBIA EL ESTADO DE LA SOLICITUD EN CUESTIÓN PARA QUE SE REFRESQUE LA TABLA DE VISTACLIENTE ADEMÁS DE LA BASE DE DATOS
            if (solicitudesAux.map(solicitud => { if (solicitud.solicitudId == action.IdSolicitud) solicitud.SolicitudEstadoId = action.idNuevoEstado }));
            if (solicitudesAuxCabal.map(solicitud => { if (solicitud.solicitudId == action.IdSolicitud) solicitud.SolicitudEstadoId = action.idNuevoEstado }));
            if (solicitudesAuxMaster.map(solicitud => { if (solicitud.solicitudId == action.IdSolicitud) solicitud.SolicitudEstadoId = action.idNuevoEstado }));


            //SE ELIMINAN DEL ARREGLO LAS SOLICITUDES CON ESTADO "ANULADA"
            solicitudesAux = solicitudesAux.filter(solicitud => solicitud.SolicitudEstadoId != 12)
            solicitudesAuxCabal = solicitudesAuxCabal.filter(solicitud => solicitud.SolicitudEstadoId != 12)
            solicitudesAuxMaster = solicitudesAuxMaster.filter(solicitud => solicitud.SolicitudEstadoId != 12)

            result = {
                ...state,
                data: {
                    ...state.data,
                    CONSULTA_SOLICITUDES_CUENTA: solicitudesAux,
                    CONSULTA_SOLICITUDES_CUENTA_CABAL: solicitudesAuxCabal,
                    CONSULTA_SOLICITUDES_CUENTA_MASTER: solicitudesAuxMaster
                }
            };
            break;

        case SET_USER_FUNCTIONS:

            result = {
                ...state,
                data: {
                    ...state.data,
                    consultaSociosFunctionsAllowed: action.consultaSociosFunctionsAllowed,
                    solicitudFunctionsAllowed: action.solicitudFunctionsAllowed,
                    deliveryFunctionsAllowed: action.deliveryFunctionsAllowed,
                    userFeatures: action.userFeatures
                }
            };
            break;

        case RELOAD_VISTA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    client: action.client
                }
            };
            break;

        case OPEN_MODAL_DISTRIBUIRLIMITES:

            result = {
                ...state,
                data: {
                    ...state.data,
                    modalVisibleLimites: true
                }
            };
            break;

        case CLOSE_MODAL_DISTRIBUIRLIMITES:

            result = {
                ...state,
                data: {
                    ...state.data,
                    modalVisibleLimites: false
                }
            };
            break;

        case ROUTE_TO_ADMINISTRADORA_VISTA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    redirect: true
                }
            };
            break;
        case ROUTE_TO_EMPRESA:

            result = {
                ...state,
                data: {
                    ...state.data,
                    redirectToEmpresa: true
                }
            };
            break;

        case ROUTE_TO_NUEVA_SOLICITUD_CUENTA_VISTA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    redirectToCuenta: true
                }
            };
            break;

        case RESET_ROUTE_TO_ADMINISTRADORA_VISTA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    redirect: false
                }
            };
            break;

        case RESET_STATE_VISTA_CLIENTE:

            state = initialState
            result = {
                ...state,
                data: {
                    ...state.data,
                    redirectToCuentaCliente: false,
                    redirectToAvisoViaje:false
                }
            };
            break;

        case ACTUALIZAR_LIMITES_VISTA_CLIENTE:

            let empresas = [];

            action.estado.empresas.forEach(function (empresa) {
                empresa.accounts = action.estado.cuentas.filter(x => x.EmpresaVisaId === empresa.Id);
                empresa.accounts.forEach(function (account) {
                    account.cards = action.estado.tarjetas.filter(x => x.CuentaTarjetaId === account.Id);
                });
                empresas.push(empresa);
            });

            for (var i = 0; i < empresas.length; i++) {
                for (var j = 0; j < action.estado.novedadesEmpresas.length; j++) {
                    if (empresas[i].Id == action.estado.novedadesEmpresas[j].EmpresaId) {
                        empresas[i].limitecompra = action.estado.novedadesEmpresas[j].ValorNovedad;
                        empresas[i].limitecompraFormato = GlobalHelper.ConvertirNumeroMilesMillones(action.estado.novedadesEmpresas[j].ValorNovedad);
                    }
                    else {
                        empresas[i].limitecompraFormato = GlobalHelper.ConvertirNumeroMilesMillones(empresas[i].limitecompra);
                    }
                }

                for (var k = 0; k < empresas[i].accounts.length; k++) {
                    for (var l = 0; l < action.estado.novedadesCuentas.length; l++) {
                        if (empresas[i].accounts[k].Id == action.estado.novedadesCuentas[l].CuentaTarjetaId) {
                            empresas[i].accounts[k].Valor = action.estado.novedadesCuentas[l].ValorNovedad;
                            empresas[i].accounts[k].ValorFormato = GlobalHelper.ConvertirNumeroMilesMillones(action.estado.novedadesCuentas[l].ValorNovedad);
                        }
                        else {
                            empresas[i].accounts[k].ValorFormato = GlobalHelper.ConvertirNumeroMilesMillones(empresas[i].accounts[k].Valor);
                        }
                    }

                    empresas[i].accounts[k].Sucursal = empresas[i].accounts[k].SucursalDescripcion;
                }

                empresas[i].denominacion = empresas[i].Denominacion;
            }

            let empresasNoModificadas = action.estado.empresasNoModificadas;

            for (var l = 0; l < empresasNoModificadas.length; l++) {
                empresasNoModificadas[l].accounts = action.estado.cuentasNoModificadas.filter(x => x.EmpresaVisaId == empresasNoModificadas[l].Id);
                for (var m = 0; m < empresasNoModificadas[l].accounts.length; m++) {
                    empresasNoModificadas[l].accounts[m].cards = action.estado.tarjetas.filter(x => x.CuentaTarjetaId === empresasNoModificadas[l].accounts[m].Id);
                }
            }

            result = {
                ...state,
                data: {
                    ...state.data,
                    enterprises: empresas,
                    empresasNoModificadas: empresasNoModificadas,
                    novedadesEmpresas: action.estado.novedadesEmpresas
                }
            };
            break;

        case OPEN_PANEL_SELECCION:

            result = {
                ...state,
                data: {
                    ...state.data,
                    entidadTipo: action.entidadTipo,
                    idEntidad: action.idEntidad,
                    activoPanelSeleccion: action.activoPanelSeleccion
                }
            };
            break;

        case RETURN_VISTA_CLIENTE:

            result = {
                ...state,
                data: {
                    ...state.data,
                    activoPanelSeleccion: false
                }
            };
            break;

        case STOP_SPINER:

            result = {
                ...state,
                data: {
                    ...state.data,
                    loading: false
                }
            };
            break;

        case CLOSE_MODAL_CONFIRMADOR:

            result = {
                ...state,
                modalVisibleConfirmador: false,
                solicitudId: undefined
            };
            break;

         case REDIRECT_TO_AVISO_VIAJE:
             
            result = {
                ...state,
                data: {
                    ...state.data,
                    redirectToAvisoViaje: true
                }
            };
            break;


        default:
            result = {
                ...state
            };
            break;
    }

    LogHelper.Out(vistaCliente.name, result);
    return result;
}

/**
 * 
 * @param {any} state
 * @param {any} estadoId
 * @param {any} estado
 */
function cambiarEstadoSolicitud(state, estadoId, estado) {
    let solicitud = state.data.GET_SOLICITUD_EN_CURSO_BY_CLIENTE.find(x => x.Numero == state.data.solicitudId);
    solicitud.EstadoId = estadoId;
    solicitud.Estado = estado;
}

export default vistaCliente;